import { auth, db, storage } from "../../../firebaseConfig";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { doc, setDoc } from "firebase/firestore";
import { getSelectedUid } from "../../../../frontend/Recruitment/Applications/Utils/UidListener";

export const writeDataS12 = async (pdfBlob) => {
  const userId = getSelectedUid(); // Get the selected UID
  if (!userId) {
    throw new Error("Invalid user.");
  }
  try {
   

    // Step 2: Save the URL to Firestore
    const docRef = doc(db, "Advisers", userId, "Personal Details", "Data");
    await setDoc(
      docRef,
      {
        // submitted: true, // Mark the form as submitted
        // pdfUrl: pdfDownloadURL, // Save the PDF download URL
        // submittedAt: new Date(), // Save the timestamp
        recruitmentApplicationApproved: true, // Mark as unapproved by default
        recruitmentApplicationApprovedAt: new Date(), // Save the timestamp
        recruitmentUpdates: [
          {
            date: new Date(),
            update: "Application Submitted",
            description: "",
          },
        ],
      },
      { merge: true } // Merge with existing data
    );

    // console.log("PDF and form data successfully written to Firestore!");
  } catch (error) {
    // console.error("Error writing PDF data to Firestore: ", error);
  }
};
